<template>
  <Modal
    v-model="modal"
    :title="$t('nonCard.selectMemberType')"
    ok-text="Next"
    cancel-text="Cancel"
    footer-hide
  >
    <div>
      <div class="radioGroupBox">
        <RadioGroup v-model="memberType">
          <Radio label="1">{{ $t("nonCard.member") }}</Radio>
          <Radio label="0">{{ $t("nonCard.nonMember") }}</Radio>
        </RadioGroup>
      </div>
      <div class="btn-box mt-20">
        <Button @click="cancel(row)">Cancel</Button>
        <Button class="ml-40 " type="primary" @click="ok()">Next</Button>
      </div>
    </div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      modal: false,
      memberType: "1"
    };
  },
  methods: {
    show() {
      this.memberType = "1";
      this.modal = true;
    },
    ok() {
      this["$common"].remove("non-real-name-card-management-item"); // 删除本地
      this["$router"].push(
        `/member-management/non-real-name-card-management/non-real-add-card?memberType=${this.memberType}`
      );
    },
    cancel() {
      this.modal = false;
    }
  }
};
</script>
<style>
.radioGroupBox,
.btn-box {
  display: flex;
  justify-content: center;
}
.radioGroupBox .ivu-radio-wrapper:last-child {
  margin-left: 0.4rem;
}
.ml-40 {
  margin-left: 0.4rem;
}
.mt-20 {
  margin-top: 0.2rem;
}
</style>
